import { ofType } from "redux-observable";
import { map, switchMap } from "rxjs/operators";
import { getJSON, postJSON, putJSON, deleteJSON } from "../utils/ajaxUtil";
import {
  REQUESTED_PHASES,
  REQUESTED_CREATE_PHASE,
  REQUESTED_UPDATE_PHASE,
  REQUESTED_DELETE_PHASE,
  REQUESTED_DELETE_VERSION_PHASE,
  receivePhases,
  receiveCreatePhase,
  receiveUpdatePhase,
  receiveDeletePhase,
  receiveDeleteVersionPhase,
} from "../redux/actions/phaseAction";

export const fetchPhases = (action$) =>
  action$.pipe(
    ofType(REQUESTED_PHASES),
    map((action) => action.payload.user),
    switchMap((user) =>
      getJSON(`/phases`).pipe(map((res) => receivePhases(res.data)))
    )
  );

export const createPhase = (action$) =>
  action$.pipe(
    ofType(REQUESTED_CREATE_PHASE),
    map((action) => action.payload.phase),
    switchMap((phase) =>
      postJSON(`/phases/`, phase).pipe(
        map((res) => receiveCreatePhase(res.data))
      )
    )
  );

export const updatePhase = (action$) =>
  action$.pipe(
    ofType(REQUESTED_UPDATE_PHASE),
    map((action) => action.payload.phase),
    switchMap((phase) =>
      putJSON(`/phases/${phase.id}/`, phase).pipe(
        map((res) => receiveUpdatePhase(res.data))
      )
    )
  );

export const deletePhase = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_PHASE),
    map((action) => action.payload.phase),
    switchMap((phase) =>
      deleteJSON(`/phases/${phase.id}`).pipe(
        map((res) => receiveDeletePhase(res.data))
      )
    )
  );

export const deleteVersionPhaseByPhase = (action$) =>
  action$.pipe(
    ofType(REQUESTED_DELETE_VERSION_PHASE),
    map((action) => action.payload.phase),
    switchMap((phase) =>
      deleteJSON(`/versionphases?phase_id=${phase.id}/`).pipe(
        map((res) => receiveDeleteVersionPhase(res.data))
      )
    )
  );
